import styled from 'styled-components';

import { colors } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  padding: 10px 20px 10px 20px;
  margin-top: 20px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.tint.primary.medium};
  box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.tint.primary.medium};
`;

export const AvailableLicensesLabel = styled.p`
  font: normal normal normal 14px Roboto;
  color: ${({ theme }) => theme.palette.text.primary};
  margin-right: 30px;
`;

export const ProductContainer = styled.div`
  display: flex;
  margin-right: 30px;
  align-items: center;
`;

export const ProductName = styled.p`
  font: normal normal normal 12px Roboto;
  color: ${colors.ui.chip.grayText};
  line-height: 14px;
  margin-left: 10px;
  margin-right: 10px;
`;

export const LicensesDetailsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LicenseStatusText = styled.p`
  font: normal normal normal 12px Roboto;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const LicenseAvailableText = styled.b`
  font: 12px Roboto;
  font-weight: 700;
`;
